const channels: Record<string, BroadcastChannel | null> = {};

const getChannel = (channelName: string): BroadcastChannel => {
  if (!channels[channelName]) {
    channels[channelName] = new BroadcastChannel(channelName);
  }

  return channels[channelName];
};

const isChannelClosed = (channelName: string) => channels[channelName] === null;

const closeChannel = (channelName: string) => {
  const channel = channels[channelName];
  if (channel) {
    channel.close();
    channels[channelName] = null;
  }
};

const closeAllChannels = () => Object.keys(channels).forEach(closeChannel);

window.addEventListener('beforeunload', closeAllChannels);

export { closeChannel, getChannel, isChannelClosed };
